/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let getAllMeetingListURL = root.getAllMeetingListUrl.link;
let createNewMeetingListURL = root.createNewMeetingListUrl.link;
let updateMeetingDetailsURL = root.updateMeetingDetailsUrl.link;
let meetingReminderApiUrl = root.meetingReminderApiUrl.link;
let checkStatueOfPubMeetingApiUrl = root.checkStatueOfPubMeetingApiUrl.link;
let getInterviewMeetingApiUrl = root.interviewMeetingApiUrl.link;
let thirtyTrailApiUrl = root.thirtyTrailApiUrl.link;



export default {
  state: {
    getMeetingState:{},
    getDeletedMeetingState:{}
  },
  mutations: {
    getMeetingMut(state, value) {
      Vue.set(state, 'getMeetingState', value);
    },
    getDeletedMeetingMutation(state, value) {
      Vue.set(state, 'getDeletedMeetingState', value);
    },
  },
  actions: {
    // Get Thirty Days Trail Action
    getThirtyDaysTrailApiUrl(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(thirtyTrailApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Thirty Days Trail Action
    updateThirtyDaysTrailApiUrl(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(thirtyTrailApiUrl).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Meeting Action
    getDeletedMeetingListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getAllMeetingListURL  + '?is_webinar=False' + '&is_deleted=true', payload).then(res => {
              context.commit('getDeletedMeetingMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Meeting Status Action
    getPubMeetingStatusAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(checkStatueOfPubMeetingApiUrl  + '?id=' + payload.id).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Meeting Status Action
    getInterviewMeetingStatusAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getInterviewMeetingApiUrl  + '?id=' + payload.id).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Meeting Reminder Action
    meetingReminderAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(meetingReminderApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Meeting Action
    getMeetingAllListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getAllMeetingListURL  + '?is_webinar=False' + '&page_size=15', payload).then(res => {
              context.commit('getMeetingMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Meeting Action
    createNewMeetingDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(createNewMeetingListURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Meeting Action
    updateMeetingDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(updateMeetingDetailsURL + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Meeting Details By IdAction
    getMeetingDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(updateMeetingDetailsURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Meeting Action
    removeMeetingDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(getAllMeetingListURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getMeetingListGetters: state => state.getMeetingState,
    getDeletedMeetingGetters: state => state.getDeletedMeetingState,
  }
}